import * as create from './create';
import * as list from './list';
import * as partsAssignment from './partsAssignment';
import * as tasksAssignment from './tasksAssignment';
import * as qualityControl from './invoice';

const reducers = {
  ...create,
  ...list,
  ...partsAssignment,
  ...tasksAssignment,
  ...qualityControl,
};

export default reducers;
